export const NAME_KEY = 'LoggedUserName'
export const SUPER_USER = 'SUPERUSER'
export const TOKEN_KEY = 'LoggedInToken'
export const USER_ID_KEY = 'USerIdKey'

export const REFRESH_TOKEN_KEY = 'refresh-token';
